import { render } from "./Welcome.vue?vue&type=template&id=314c265f"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=314c265f&lang=css"

import exportComponent from "E:\\backup\\Programowanie\\scheduler\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__